import styled from "styled-components";

import { Color, Ease, Device } from "@styles/constants";
import { XSmallBodyRegularCSS, XSmallBodyMediumCSS } from "@styles/typography";

export const BundleSlider = styled.div`
  position: relative;
  overflow: hidden;

  .swiper-slide {
    background: ${Color.grayFill};

    img {
      object-fit: contain;
      mix-blend-mode: multiply;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
    position: absolute;
    top: 50%;
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1;
    border: 1px solid ${Color.grayInactive};
    transform: translateY(-50%);
    transition: opacity ${Ease.duration} ${Ease.out}, background ${Ease.duration} ${Ease.out};

    &:focus-visible {
      outline: -webkit-focus-ring-color auto 1px;
    }

    svg {
      fill: ${Color.blackBrand};
      width: 11px;
      height: 11px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.4);
    }

    @media ${Device.mediumUp} {
      display: flex;
    }
  }

  .swiper-button-next {
    right: 20px;

    svg {
      margin-right: 2px;

      @media ${Device.largeUp} {
        margin-top: 2px;
      }

      transform: rotate(-90deg);
    }
  }

  .swiper-button-prev {
    left: 20px;

    svg {
      margin-left: 2px;

      @media ${Device.largeUp} {
        margin-top: 2px;
      }

      transform: rotate(90deg);
    }
  }

  .swiper-pagination {
    bottom: 30px;
    left: 0;
    width: 100%;
  }

  .swiper-pagination-item {
    > span:first-child {
      ${XSmallBodyMediumCSS}
    }

    > span:last-child {
      ${XSmallBodyRegularCSS}
      color: ${Color.grayBrand};
    }
  }

  .swiper-caption {
    ${XSmallBodyMediumCSS}
    color: ${Color.grayBrand};
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
    bottom: 30px;
    left: 0;
    width: 100%;
  }
`;
